import { types } from "mobx-state-tree"

const RallySafeRally = types.model('RallySafeRally', {
    id: types.identifierNumber,
    provider_rally_id: types.integer,
    name: types.string,
})

export default RallySafeRally
